import type { FaireProductEntity } from "../../entity_types/product";

export const fable_home_3: FaireProductEntity = {
  token: "fable-home-3",
  type: "product",
  name: "Cotton Napkin Set",
  brandName: "Fable Home",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/69a8466c8a06627e3bdb24d3e2be2702352462b757d5e19ce189a8dfebc5bd8e.webp",
  priceDollars: 45,
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/4c38e4ee3cce8e1ab8ce4c00ccb9fff7264b2c9a3b219f238f775e86ea3cc12c.webp",
  weight: 1,
  dimensions: {
    width: 18,
    height: 18,
    depth: 2,
  },
  description: "Set of linen napkins for everyday dining.",
  categoryTokens: ["cat_accessories"],
  tags: ["linen", "tableware", "napkins"],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-compass-migration",
  },
};
